import * as R from 'ramda';
import angular from 'angular';


export default function EditVendorManagerDialogController(
  $q,
  $scope,
  alerts,
  loaderService,
  ssDialogService,
  vmDataService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleEditVendorManagerFormSubmit = _handleEditVendorManagerFormSubmit;
  vm.handleSelectAllVendors = _handleSelectAllVendors;

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _handleEditVendorManagerFormSubmit() {
    loaderService.showViewLoader = true;
    const selectedVendors = R.filter(
      R.propEq('isSelected', true),
      vm.vendorManager.vendors
    );

    const vendorIds = [];
    angular.forEach(selectedVendors, (vendor) => {
      if (vendor.isSelected) {
        vendorIds.push(vendor.vendorId);
      }
    });

    vm.vendorManager.vendors = selectedVendors;
    vm.vendorManager.vendorCount = selectedVendors.length;
    vmDataService.assignVendorManager(vm.vendorManager.vendorManagerId, vendorIds)
      .then((response) => {
        loaderService.showViewLoader = false;
        alerts.success('The Vendor Manager was saved successfully.');
        console.log(response);
        _closeDialog();
      });
  }

  function _handleSelectAllVendors() {
    R.forEach((item) => {
      item.isSelected = vm.allVendorsSelected;
    }, vm.vendorManager.vendors);
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.editVendorManagerDialog);
  }
}

EditVendorManagerDialogController.$inject = [
  '$q',
  '$scope',
  'alerts',
  'loaderService',
  'ssDialogService',
  'vmDataService'
];
